import { NavLink, Outlet } from 'react-router';

const NAV_LINKS = [
  { label: 'Contract Entry', to: '/' },
  { label: 'Quality Formulas', to: '/quality-formulas' },
  { label: 'Templates', to: '/templates' },
];

// A persistent entry point into the Quality Formulas/Templates experience — those pages live at
// their own routes (not "/"), so without this nav there's no way to reach them from the embedded
// LWC's default landing page. Plain SLDS (not Mantine) since this wraps every route, including
// the SLDS-styled HomePage.
const HostNav: React.FC = () => (
  <nav aria-label="Primary" className="slds-p-around_small slds-border_bottom">
    <ul className="slds-button-group">
      {NAV_LINKS.map(link => (
        <li key={link.to}>
          <NavLink
            className={({ isActive }) => `slds-button slds-button_neutral${isActive ? ' slds-button_brand' : ''}`}
            end={link.to === '/'}
            to={link.to}
          >
            {link.label}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);

export const Layout = ({ availableEmbedHeight }: { availableEmbedHeight?: number }) => (
  <main
    className="slds-template_default"
    style={{ background: 'var(--slds-g-color-surface-2)', minHeight: availableEmbedHeight }}
  >
    <HostNav />
    <Outlet />
  </main>
);
